import { organization_type } from "@/models/organization.model";
import { z } from "zod";
import { FormFieldDef } from "@/components/shared/form-creator";

export const baseSchema = z
  .object({
    name: z.string().min(2),
    email: z.string().email(),
    phone: z.string().optional(),
    password: z.string().min(8),
    confirm: z.string(),
    organizationType: z.nativeEnum(organization_type),
    organizationName: z.string().optional(),
  })
  .refine((v) => v.password === v.confirm, {
    path: ["confirm"],
    message: "Passwords must match",
  });

export const getFields = (opts: { showOrgType: boolean; showOrgName: boolean }): FormFieldDef[] => [
  ...(opts.showOrgType
    ? [
        {
          type: "select",
          name: "organizationType",
          label: "Organization type",
          placeholder: "Select Organization Type",
          required: true,
          options: [
            { value: organization_type.pmc, label: "Property Manager" },
            { value: organization_type.vendor, label: "Vendor" },
            { value: organization_type.subs, label: "Sub-contractor" },
          ],
        } as FormFieldDef,
      ]
    : []),
  ...(opts.showOrgName
    ? [
        {
          type: "text",
          name: "organizationName",
          label: "Organization Name",
          required: true,
        } as FormFieldDef,
      ]
    : []),
  { type: "text", name: "name", label: "Full name", required: true },
  { type: "email", name: "email", label: "Email", required: true },
  { type: "text", name: "phone", label: "Phone" },
  { type: "password", name: "password", label: "Password", required: true },
  {
    type: "password",
    name: "confirm",
    label: "Confirm password",
    required: true,
  },
];
